var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sid-select"},[_c('draggable',{attrs:{"list":_vm.products,"handle":".move"}},_vm._l((_vm.products),function(product,index){return _c('div',{key:index,staticClass:"m-[4px] gap-y-[4px]"},[_c('div',{staticClass:"group rounded-[2px] h-[38px] flex items-center pl-[16px] hover:bg-[#F1F5FD] cursor-pinter"},[_c('svg',{staticClass:"move cursor-move mr-[14px]",attrs:{"fill":"none","height":"10","viewBox":"0 0 10 10","width":"10","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.57745 0H0.568359V3H3.57745V0Z","fill":"#3D82EA"}}),_c('path',{attrs:{"d":"M10.5984 0H7.58936V3H10.5984V0Z","fill":"#3D82EA"}}),_c('path',{attrs:{"d":"M3.57745 7H0.568359V10H3.57745V7Z","fill":"#3D82EA"}}),_c('path',{attrs:{"d":"M10.5984 7H7.58936V10H10.5984V7Z","fill":"#3D82EA"}})]),_c('span',{staticClass:"text-truncate max-w-[165px] text-[15px] group-hover:text-[#3D82EA]"},[_vm._v(" "+_vm._s(product.name)+" ")])])])}),0),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Plan Headline","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('b-form-group',{attrs:{"label":"Plan Text"}},[_c('b-form-input',{model:{value:(_vm.element.options.content.productOptions.plan.text),callback:function ($$v) {_vm.$set(_vm.element.options.content.productOptions.plan, "text", $$v)},expression:"element.options.content.productOptions.plan.text"}})],1),_c('sid-font',{attrs:{"sid":`.--${_vm.element.sid}--header-name`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.element.sid}--header-name`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":`.--${_vm.element.sid}--header-name`,"rule-name":"letter-spacing","min":-2,"dimensions":[]}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":`.--${_vm.element.sid}--header-name`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--header-name`,"rule-name":"color"}})],1)])],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Price Headline","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('b-form-group',{attrs:{"label":"Price Text"}},[_c('b-form-input',{model:{value:(_vm.element.options.content.productOptions.price.text),callback:function ($$v) {_vm.$set(_vm.element.options.content.productOptions.price, "text", $$v)},expression:"element.options.content.productOptions.price.text"}})],1),_c('sid-font',{attrs:{"sid":`.--${_vm.element.sid}--product-name`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.element.sid}--product-name`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":`.--${_vm.element.sid}--product-name`,"rule-name":"letter-spacing","min":-2,"dimensions":[]}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":`.--${_vm.element.sid}--product-name`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--product-name`,"rule-name":"color"}})],1)])],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Product Options","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Active', 'Hover']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-font',{attrs:{"sid":`.--${_vm.element.sid}--product-name`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`.--${_vm.element.sid}--product-name`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"label":"Letter-Spacing","sid":`.--${_vm.element.sid}--product-name`,"rule-name":"letter-spacing","min":-2,"dimensions":[]}}),_c('sid-range-slider',{attrs:{"label":"Line-Height","sid":`.--${_vm.element.sid}--product-name`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--product-name`,"rule-name":"color"}})],1)]),_c('hr'),_c('div',{staticClass:"flex w-full items-center justify-between mb-[14px]"},[_c('label',{staticClass:"pb-0"},[_vm._v(" Background Color: ")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--product`,"rule-name":"background-color"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.element.sid}--product`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--product`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--product`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--product`,"rule-name":"border","angles":[
            {
              text: 'Top Left',
              value: 'top-left-radius'
            },
            {
              text: 'Top Right',
              value: 'top-right-radius'
            },
            {
              text: 'Bottom Left',
              value: 'bottom-left-radius'
            },
            {
              text: 'Bottom Right',
              value: 'bottom-right-radius'
            }
          ]}}),_c('hr'),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.element.sid}--product`,"rule-name":"padding","min":0,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.element.sid}--product`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true},{key:"Active",fn:function(){return [_c('div',{staticClass:"flex w-full items-center justify-between mb-[14px]"},[_c('label',{staticClass:"pb-0"},[_vm._v(" Background Color: ")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--product.active`,"rule-name":"background-color"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.element.sid}--product.active`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--product.active`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--product.active`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--product.active`,"rule-name":"border","angles":[
            {
              text: 'Top Left',
              value: 'top-left-radius'
            },
            {
              text: 'Top Right',
              value: 'top-right-radius'
            },
            {
              text: 'Bottom Left',
              value: 'bottom-left-radius'
            },
            {
              text: 'Bottom Right',
              value: 'bottom-right-radius'
            }
          ]}}),_c('hr'),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.element.sid}--product.active`,"rule-name":"padding","min":0,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.element.sid}--product.active`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('div',{staticClass:"flex w-full items-center justify-between mb-[14px]"},[_c('label',{staticClass:"pb-0"},[_vm._v(" Background Color: ")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--product`,"presudo":":hover","rule-name":"background-color"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.element.sid}--product`,"presudo":":hover","rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.element.sid}--product`,"presudo":":hover","label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--product`,"presudo":":hover","rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.element.sid}--product`,"presudo":":hover","rule-name":"border","angles":[
            {
              text: 'Top Left',
              value: 'top-left-radius'
            },
            {
              text: 'Top Right',
              value: 'top-right-radius'
            },
            {
              text: 'Bottom Left',
              value: 'bottom-left-radius'
            },
            {
              text: 'Bottom Right',
              value: 'bottom-right-radius'
            }
          ]}}),_c('hr'),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.element.sid}--product`,"presudo":":hover","rule-name":"padding","min":0,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.element.sid}--product`,"presudo":":hover","rule-name":"margin","min":-2000,"max":2000,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Variant","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Active', 'Hover']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-font',{attrs:{"prefix":"Variant","sid":`.--${_vm.element.sid}--variant-name`}}),_c('sid-range-slider',{attrs:{"label":"Variant Font Size","sid":`.--${_vm.element.sid}--variant-name`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"prefix":"Variant","label":"Letter-Spacing","sid":`.--${_vm.element.sid}--variant-name`,"rule-name":"letter-spacing","min":-2,"dimensions":[]}}),_c('sid-range-slider',{attrs:{"prefix":"Variant","label":"Line-Height","sid":`.--${_vm.element.sid}--variant-name`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Variant Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--variant-name`,"rule-name":"color"}})],1)]),_c('hr'),_c('sid-font',{attrs:{"prefix":"Price","sid":`.--${_vm.element.sid}--variant-price`}}),_c('sid-range-slider',{attrs:{"label":"Price Font Size","sid":`.--${_vm.element.sid}--variant-price`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('sid-range-slider',{attrs:{"prefix":"Price","label":"Letter-Spacing","sid":`.--${_vm.element.sid}--variant-price`,"rule-name":"letter-spacing","min":-2,"dimensions":[]}}),_c('sid-range-slider',{attrs:{"prefix":"Price","label":"Line-Height","sid":`.--${_vm.element.sid}--variant-price`,"rule-name":"line-height","default-dimension":'',"min":0,"max":5,"step":.1,"var":"--line-height","dimensions":[]}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Price Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--variant-price`,"rule-name":"color"}})],1)])]},proxy:true},{key:"Active",fn:function(){return [_c('sid-font',{attrs:{"prefix":"Variant","sid":`.--${_vm.element.sid}--variant-name.active`}}),_c('sid-range-slider',{attrs:{"label":"Variant Font Size","sid":`.--${_vm.element.sid}--variant-name.active`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Variant Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--variant-name.active`,"rule-name":"color"}})],1)]),_c('hr'),_c('sid-font',{attrs:{"prefix":"Price","sid":`.--${_vm.element.sid}--variant-price.active`}}),_c('sid-range-slider',{attrs:{"label":"Price Font Size","sid":`.--${_vm.element.sid}--variant-price.active`,"default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Price Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--variant-price.active`,"rule-name":"color"}})],1)])]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-font',{attrs:{"prefix":"Variant","sid":`.--${_vm.element.sid}--variant-name`,"presudo":":hover"}}),_c('sid-range-slider',{attrs:{"label":"Variant Font Size","sid":`.--${_vm.element.sid}--variant-name.active`,"presudo":":hover","default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Variant Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--variant-name.active`,"presudo":":hover","rule-name":"color"}})],1)]),_c('hr'),_c('sid-font',{attrs:{"prefix":"Price","sid":`.--${_vm.element.sid}--variant-price`,"presudo":":hover"}}),_c('sid-range-slider',{attrs:{"label":"Price Font Size","sid":`.--${_vm.element.sid}--variant-price.active`,"presudo":":hover","default-dimension":"px","px-range":[0, 300],"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Price Text Color")]),_c('sid-color',{attrs:{"sid":`.--${_vm.element.sid}--variant-price.active`,"presudo":":hover","rule-name":"color"}})],1)])]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Padding, Margins","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.element.sid}--wrapper`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.element.sid}--wrapper`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }